// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__MKcK-","title":"ClientCherryInfo_title__1tF8H","itemText":"ClientCherryInfo_itemText__2fYLV"};